import sendEmail from './'

import { homeUrl } from 'config'

const sendTermsEmail = (userEmail: string, hash: string, userName: string) => {
  const subject = 'Verify your email address'

  const body = `
  <html>

  <body>
    <div style="
        text-align: center;
      ">
      <div style="
      border: 1px solid rgb(235, 235, 237);
      border-radius: 2px;
      text-align: center;
      max-width: 43.75rem;
      margin: 0 auto;
    ">
        <div style="margin: 3rem auto 0;">
          <a href="${homeUrl}">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/giantleap-82ce7.appspot.com/o/images%2FEmailLogo.png?alt=media&token=cc9bb3bd-11d1-4a2a-adb7-80f41c2da2cc"
              alt="" style="
        width: 7rem;
      " />
          </a>
        </div>
        <h3 style="
        font-size: 24px;
        color: #1a242e;
        font-family: montserrat,Helvetica,sans-serif;
        margin: 2.5rem auto 0;
      ">
          Hi ${userName || ''}
        </h3>
        <p style="
        font-family: tahoma,sans-serif;
        color: rgb(65,62,77);
        font-size: 16px;
        margin: 1rem auto 2rem;
      ">
          Please click on the button below to activate your account:
        </p>
        <a href="${homeUrl}/confirmation/${userEmail}?termsOfUse=accept&hash=${hash}" style="
          background: #ff20e9;
          color: #ffffff;
          font-family: tahoma,sans-serif;
          font-size: 18px;
          font-weight: normal;
          margin: 2rem auto 0;
          text-decoration: none;
          text-transform: uppercase;
          border-radius: 2px;
          padding: 0.5rem 2rem;
        ">Verify my email</a>
        <p style="
          color: #413e4d;
          margin: 3.5rem auto 0;
        ">Have a great day,<br />
          GiantLeap Team</p>
        <p style="
        color: #aaaaaa;
        font-family: tahoma,sans-serif;
        margin: 1.5rem auto 0;
      ">Need help? Contact <a style="color: #4190ff;" href="mailto:${
        process.env.REACT_APP_SUPPORT_EMAIL
      }">support@giantleap.tech</p>
        <p style="
        font-family: helvetica,sans-serif;
        line-height: 1.5;
        font-size: 12px;
        color: #030303;
        margin: 3.5rem auto 3.5rem;
      ">
          181 Metro Dr Ste 410<br />
          San Jose, CA 95110-134
        </p>
      </div>
    </div>
  </body>
  
  </html>
  `

  const text = `
  This email is being sent to obtain your consent to the collection, and use of personal information about your child
  via their use of GiantLeap Child Assessment Application. We will not collect, use, or disclose any personal
  information about your child without your consent. Personal information regarding your child will not be visible to
  other users of our service nor will we send such information to others explicitly approved by you. You may authorize
  us on a case-by-case basis to send certain information about your child to their caregiver or any type of
  educational or developmental service provider.
  By confirming the setting up your child GiantLeap account using the above link, you consent to the collection and
  use of the following in accordance with our Privacy
  Policy (https://www.giantleap.tech/privacy) and Terms of Use (https://www.giantleap.tech/terms).
  If this email address has been provided without your consent or if you wish to delete the account request for any reason, please send an email to privacy@giantleap.tech
  To confirm visit ${homeUrl}/confirmation/${userEmail}?termsOfUse=accept&hash=${hash}
  To decline visit ${homeUrl}/confirmation/${userEmail}?termsOfUse=decline&hash=${hash}
  `

  return sendEmail(userEmail, subject, body, text)
}

export default sendTermsEmail



// WEBPACK FOOTER //
// ./src/services/email/termsEmail.ts